import { useQuery } from '@tanstack/react-query';
import { api } from '../api-client.config';
import { queryKeys } from '../react-query.config';

/**
 * Per-player roster stats used to sort player selection lists by activity.
 * `gamesPlayed` is null for sports/players where the feed has no such data
 * (e.g. soccer national sides) — those fall back to alphabetical ordering.
 */
export interface TeamRosterStatsResponse {
  players: Array<{ id: string; gamesPlayed: number | null }>;
}

export const getTeamRosterStats = async (
  leagueId: string,
  teamId: string
): Promise<TeamRosterStatsResponse> => {
  return (await api.get(
    `/feed/leagues/${leagueId}/teams/${teamId}/season-stats`
  )) as TeamRosterStatsResponse;
};

export const useGetTeamRosterStatsQuery = (leagueId?: string, teamId?: string) => {
  return useQuery({
    queryKey: queryKeys.feed.teamRosterStats(leagueId ?? '', teamId ?? ''),
    queryFn: () => getTeamRosterStats(leagueId!, teamId!),
    enabled: !!leagueId && !!teamId,
    staleTime: 1000 * 60 * 10,
    retry: 1,
  });
};
